module.exports = new __parcel__URL__("generic.28da7925.svg").toString();